(() => {
  const root = document.querySelector('.snk-locator');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const container = root.querySelector('#storepoint-container');
  const status = root.querySelector('[data-locator-status]');
  const message = root.querySelector('[data-locator-message]');
  let timer;
  let ready = false;
  container.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      container.querySelector('.mapboxgl-popup-close-button')?.click();
    }
    if (event.target.matches('.storepoint-location') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.target.click();
    }
  });
  const checkReady = () => {
    container.querySelectorAll('.storepoint-location:not([tabindex])').forEach(card => {
      card.tabIndex = 0;
      card.setAttribute('role', 'button');
      card.setAttribute('aria-label', `Show ${card.querySelector('.storepoint-name')?.textContent || 'store'} on map`);
    });
    container.querySelector('.mapboxgl-popup-close-button')?.removeAttribute('aria-hidden');
    if (ready) return;
    if (!container.querySelector('#storepoint-search input') || !container.querySelector('.mapboxgl-canvas, .gm-style')) return;
    status.hidden = true;
    root.classList.add('snk-locator--ready');
    clearTimeout(timer);
    ready = true;
    // The vendor initially sizes the map before our responsive grid settles.
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  };
  const observer = new MutationObserver(checkReady);
  observer.observe(container, { childList: true, subtree: true });
  const failed = () => {
    status.hidden = false;
    message.textContent = 'The map is taking longer to load. You can also use our full store locator.';
  };
  timer = setTimeout(failed, 20000);
  const src = 'https://cdn.storepoint.co/api/v1/js/15fb2b46f6172b.js';
  if (!document.querySelector('script[data-snk-storepoint]')) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.snkStorepoint = 'true';
    script.addEventListener('error', failed, { once: true });
    document.head.appendChild(script);
  }
  checkReady();
})();
